import { Sparkles } from "lucide-react";
import { Outlet, useLocation } from "react-router-dom";

import { usePortal } from "@/features/portal/portal-context";
import { AdminViewBanner } from "@/features/portal/admin-view-banner";
import { Sidebar } from "@/features/portal/sidebar";
import { TopBar } from "@/features/portal/top-bar";

export function PortalLayout() {
  const { welcome, dismissWelcome } = usePortal();
  const { pathname } = useLocation();
  // The save/publish TopBar only belongs on the brand editors. The create flow,
  // landing redirect and admin directory have no active draft to publish.
  const showTopBar = pathname.startsWith("/b/");

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar />
      <main className="flex min-w-0 flex-1 flex-col">
        {/* Banner + top bar stick together so the "admin view" cue stays pinned
            with the publish controls as the editor scrolls. */}
        {showTopBar && (
          <div className="sticky top-0 z-30">
            <AdminViewBanner />
            <TopBar />
          </div>
        )}
        <div className="w-full max-w-[1180px] px-9 pb-20 pt-[30px]">
          {welcome && (
            <div className="mb-6 flex items-center gap-3.5 rounded-2xl border border-border-strong bg-[linear-gradient(95deg,rgba(224,55,154,.12),rgba(79,110,247,.12))] px-[18px] py-4">
              <div className="grid size-[38px] shrink-0 place-items-center rounded-xl bg-brand-gradient">
                <Sparkles className="size-5 text-white" />
              </div>
              <div className="flex-1">
                <div className="text-[14.5px] font-bold">
                  Welcome — “{welcome}” is ready to customize
                </div>
                <div className="mt-0.5 text-[13px] text-muted-foreground">
                  We created your first brand automatically. Set your colors and currency below.
                </div>
              </div>
              <button
                onClick={dismissWelcome}
                className="cursor-pointer p-1 text-lg text-text-3 hover:text-foreground"
                aria-label="Dismiss"
              >
                ×
              </button>
            </div>
          )}
          <Outlet />
        </div>
      </main>
    </div>
  );
}
